module.exports = __webpack_public_path__ + "static/media/SolarTrack.f6b40fb9.jpg";